import { render, staticRenderFns } from "./PivotTable.vue?vue&type=template&id=4219a560&scoped=true"
import script from "./PivotTable.vue?vue&type=script&lang=js"
export * from "./PivotTable.vue?vue&type=script&lang=js"
import style0 from "./PivotTable.vue?vue&type=style&index=0&id=4219a560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4219a560",
  null
  
)

export default component.exports